/** Represents an error that occurred during a fetch request. */
export class RestError extends Error {
  constructor(message: string, public response: Response) {
    super(message);
    this.name = 'RestError';
  }
}
